define.alias("shared/helpers/has-item", "settings/helpers/has-item");